import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const installmentPickerStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  trigger: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing.small,
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.colors.inputBorder,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.inputBg,
    cursor: 'pointer',
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  } as CSSProperties,

  triggerOpen: {
    borderColor: theme.colors.inputBorder,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  } as CSSProperties,

  triggerHasSelection: {
    backgroundColor: theme.colors.palette.lightBlue275,
    borderColor: theme.colors.button.primary,
  } as CSSProperties,

  triggerPlaceholder: {
    color: theme.colors.placeholder,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
  } as CSSProperties,

  triggerSelected: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.small,
    overflow: 'hidden',
  } as CSSProperties,

  triggerSelectedLabel: {
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
    whiteSpace: 'nowrap',
  } as CSSProperties,

  triggerSelectedTotal: {
    marginLeft: 'auto',
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    whiteSpace: 'nowrap',
  } as CSSProperties,

  chevron: {
    flexShrink: 0,
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.label,
    transition: `transform ${theme.transitions.fast}`,
  } as CSSProperties,

  chevronOpen: {
    transform: 'rotate(180deg)',
  } as CSSProperties,

  panel: {
    // Longhand (no `border`): el modificador de foco/error pisa `borderColor` sin mezclar propiedades.
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.colors.inputBorder,
    borderTop: 'none',
    borderBottomLeftRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    boxShadow: theme.shadows.md,
    backgroundColor: theme.colors.background,
    overflow: 'hidden',
  } as CSSProperties,

  panelHasSelection: {
    borderColor: theme.colors.button.primary,
  } as CSSProperties,

  panelTitle: {
    padding: `${theme.spacing.small}px ${theme.spacing.medium}px`,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.label,
    borderBottom: `1px solid ${theme.colors.inputBorder}`,
  } as CSSProperties,
};
